document.addEventListener('DOMContentLoaded', () => {
  const container = document.querySelector('.jump-to__anchors');

  if (!container) return;

  container.addEventListener('click', (event) => {
    // 1. Identify the clicked button
    const clickedBtn = event.target.closest('button');

    // Safety check: ensure a button was clicked inside our container
    if (!clickedBtn || !container.contains(clickedBtn)) return;

    // 2. Manage Classes for ALL buttons in the container
    const allButtons = container.querySelectorAll('button');

    allButtons.forEach((btn) => {
      // Set everyone to tertiary, remove primary
      btn.classList.remove('button--primary');
      btn.classList.add('button--tertiary');
    });

    // 3. Set the ACTIVE button to primary
    clickedBtn.classList.add('button--primary');
    clickedBtn.classList.remove('button--tertiary');

    // 4. Smooth Scroll Logic
    const targetValue = clickedBtn.getAttribute('data-target');
    if (targetValue) {
      const destination = document.querySelector(`[data-state="${targetValue}"]`);
      if (destination) {
        destination.scrollIntoView({
          behavior: 'smooth',
          block: 'start'
        });
      }
    }
  });
});
